import React, { useState } from "react";
import { Link } from "react-router-dom"; // Import Link
import user1 from "../assets/images/people1.svg";
import user2 from "../assets/images/people2.svg";
import user3 from "../assets/images/people3.svg";
import { FaSquarePollHorizontal } from "react-icons/fa6";
import { FaUsers, FaUserFriends } from "react-icons/fa"; // Icons

const users = [
  {
    id: 1,
    username: "Martin Zwilling",
    member: "790",
    profilePic: user1,
    members: "12.4k",
    following: "5.2K",
    posts: "860",
    polls: "4",
    date:"2025-04-06T17:00:00",
    location: "South Korea", 
    description: "Pulp, the cocktail bar at The Park, Kolkata epitomizes the glamour and the style of the 60s. The highlight of the place is its spatial simplicity!!",
  },
  {
    id: 2,
    username: "John Doe",
    member: "680",
    profilePic: user2,
    members: "12.4k",
    following: "588",
    posts: "860",
    polls: "4",
    date:"2025-04-16T17:00:00",
    location: "UK", 
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    id: 3,
    username: "Rose Winslet",
    member: "590",
    profilePic: user3,
    members: "12.4k",
    following: "2.5K",
    posts: "860",
    polls: "4",
    date:"2025-04-12T17:00:00",
    location: "USA", 
    description: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.",
  },
  {
    id: 4,
    username: "John Doe",
    member: "750",
    profilePic: user1,
    members: "12.4k",
    following: "850",
    posts: "860",
    polls: "4",
    date:"2025-03-06T17:00:00",
    location: "South Korea", 
    description: "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour.",
  },
  {
    id: 5,
    username: "Rose Winslet",
    member: "680",
    profilePic: user2,
    members: "12.4k",
    following: "900",
    posts: "860",
    polls: "4",
    date:"2025-02-16T17:00:00",
    location: "USA", 
    description: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    id: 6,
    username: "John Doe",
    member: "590",
    profilePic: user3,
    members: "12.4k",
    following: "2.4k",
    posts: "860",
    polls: "4",
    date:"2025-05-06T17:00:00",
    location: "UK", 
    description: "Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old.",
  }
];

const User = ({ user }) => {
  return (
    <Link 
      to={`/users/${user.id}`} 
      state={{ user }}  // Passing data via React Router state
      className="publication-card publication-card-ancher"
    >
      <div className="left-section">
        <div className="publication-logo">
          <img src={user.profilePic} alt={user.username} />
        </div>
        <div className="publication-info">
          <h4>{user.username}</h4>
          <p className="info-state"><FaUsers/>{user.member} followers</p>
          <p className="info-state"><FaUserFriends />{user.following} Following</p>
          <p className="info-state"><FaSquarePollHorizontal /> {user.posts} Posts & {user.polls} Polls</p>
        </div>
      </div>
    </Link>
  );
};

const UserList = () => {
  const [visible, setVisible] = useState(4);

  const handleViewMore = () => {
    setVisible((prev) => prev + 4);
  };

  return (
    <div className="newsportal-wrapper clubs">
      {users.slice(0, visible).map((user) => (
        <User key={user.id} user={user} />
      ))}

      {visible < users.length && (
        <button className="view-more-btn" onClick={handleViewMore}>
          View More
        </button>
      )}
    </div>
  );
};

export default UserList;
